import React from 'react';
import css from 'src/styles/App.scss';
import Locale from 'src/i18n';
import { Stack } from '@mui/material';
import { Label, formatMessage } from 'cw-ui-core';

function NonLoggedInAppBanner() {
    return (
        <div className={css.bannerContainer} data-testid="nonLoggedInAppBanner">
            <Label value={formatMessage(Locale.ssoAppTitle)} className={css.appTitle} />
            <Stack direction="row" spacing={1} mt={3}></Stack>
        </div>
    );
}

export default NonLoggedInAppBanner;
